import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDcy2F1DXG_v1VNB2Mmp5zrj7DQyEwhdVo",
  authDomain: "emi-project-9e4a4.firebaseapp.com",
  projectId: "emi-project-9e4a4",
  storageBucket: "emi-project-9e4a4.firebasestorage.app",
  messagingSenderId: "771580029644",
  appId: "1:771580029644:web:debf12954f822a9ef73069",
  measurementId: "G-K0B2CP44K1"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const db = getFirestore(app);

setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error("Auth persistence error:", error);
});
